import React from "react";
import { Tooltip as AriaTooltip, TooltipTrigger } from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import themeStyles from "../../styles/themes-2026.module.scss";
import styles from "./index.module.scss";

interface TooltipProps {
    label: string;
    /**
     * When `true`, forces the tooltip open; user cannot dismiss.
     * Pass `undefined` for default hover/focus behavior.
     */
    isOpen?: boolean;
    children: React.ReactElement;
}

export const Tooltip = ({ label, isOpen, children }: TooltipProps) => (
    <TooltipTrigger delay={200} isOpen={isOpen}>
        {children}
        <AriaTooltip
            className={concatClassNames([themeStyles.black, styles.tooltip])}
        >
            {label}
        </AriaTooltip>
    </TooltipTrigger>
);
